var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","large":"","color":"#1D3557","dark":""},on:{"click":_vm.backClicked}},'v-btn',attrs,false),on),[_c('icon',{attrs:{"icon":"arrow-left"}})],1)]}}])},[_c('span',[_vm._v("Back to "+_vm._s(_vm.conversationType))])])}
var staticRenderFns = []

export { render, staticRenderFns }